import * as types from '../../../actions/candidate/candidate-profile/types';
import Immutable from 'immutable';
import reducerCreator from '../../../tools/reducer-creator';
import { candidateProfileStateKeys } from '../../../constants/candidate-profile';

const initialState = Immutable.fromJS({
  [candidateProfileStateKeys.isLoading]: false,
  [candidateProfileStateKeys.isSubmitting]: false,
  [candidateProfileStateKeys.profileSectionsStates]: null,
  [candidateProfileStateKeys.profileSectionsStatesIsLoading]: false,
  [candidateProfileStateKeys.biographicalInformation]: null,
  [candidateProfileStateKeys.housingPreferences]: null,
  [candidateProfileStateKeys.health]: null,
  [candidateProfileStateKeys.sportActivities]: null,
  [candidateProfileStateKeys.personal]: null,
  [candidateProfileStateKeys.secondarySchools]: null,
  [candidateProfileStateKeys.teachingExperience]: null,
  [candidateProfileStateKeys.contactInformation]: null,
  [candidateProfileStateKeys.universitiesColleges]: null,
  [candidateProfileStateKeys.teachingCredentials]: null
});

export default reducerCreator(initialState, {
  [types.CANDIDATE_PROFILE_RESET_PROFILE_STATE]: () => initialState,
  [types.CANDIDATE_PROFILE_SET_LOADING_LOADER]: (state, { isLoading }) =>
    state.set(candidateProfileStateKeys.isLoading, isLoading),
  [types.CANDIDATE_PROFILE_SET_PROFILE_SECTIONS_STATES_LOADING_LOADER]: (
    state,
    { isLoading }
  ) =>
    state.set(
      candidateProfileStateKeys.profileSectionsStatesIsLoading,
      isLoading
    ),
  [types.CANDIDATE_PROFILE_SET_SUBMITTING_LOADER]: (state, { isSubmitting }) =>
    state.set(candidateProfileStateKeys.isLoading, isSubmitting),
  [types.CANDIDATE_PROFILE_SET_BIOGRAPHICAL_INFORMATION]: (
    state,
    { biographicalInformation }
  ) =>
    state.set(
      candidateProfileStateKeys.biographicalInformation,
      Immutable.fromJS(biographicalInformation)
    ),
  [types.CANDIDATE_PROFILE_SET_PROFILE_SECTIONS_STATES]: (
    state,
    { profileSectionsStates }
  ) =>
    state.set(
      candidateProfileStateKeys.profileSectionsStates,
      Immutable.fromJS(profileSectionsStates)
    ),
  [types.CANDIDATE_PROFILE_SET_HOUSING_PREFERENCES]: (
    state,
    { housingPreferences }
  ) =>
    state.set(
      candidateProfileStateKeys.housingPreferences,
      Immutable.fromJS(housingPreferences)
    ),
  [types.CANDIDATE_PROFILE_SET_HEALTH]: (state, { health }) =>
    state.set(candidateProfileStateKeys.health, Immutable.fromJS(health)),
  [types.CANDIDATE_PROFILE_SET_SPORT_ACTIVITIES]: (
    state,
    { sportActivities }
  ) =>
    state.set(
      candidateProfileStateKeys.sportActivities,
      Immutable.fromJS(sportActivities)
    ),
  [types.CANDIDATE_PROFILE_SET_LANGUAGES]: (state, { languages }) =>
    state.set(candidateProfileStateKeys.languages, Immutable.fromJS(languages)),
  [types.CANDIDATE_PROFILE_SET_PERSONAL]: (state, { personal }) =>
    state.set(candidateProfileStateKeys.personal, Immutable.fromJS(personal)),
  [types.CANDIDATE_PROFILE_SET_SECONDARY_SCHOOLS]: (
    state,
    { secondarySchools }
  ) =>
    state.set(
      candidateProfileStateKeys.secondarySchools,
      Immutable.fromJS(secondarySchools)
    ),
  [types.CANDIDATE_PROFILE_SET_TEACHING_EXPERIENCE]: (
    state,
    { teachingExperience }
  ) =>
    state.set(
      candidateProfileStateKeys.teachingExperience,
      Immutable.fromJS(teachingExperience)
    ),
  [types.CANDIDATE_PROFILE_SET_CONTACT_INFORMATION]: (
    state,
    { contactInformation }
  ) =>
    state.set(
      candidateProfileStateKeys.contactInformation,
      Immutable.fromJS(contactInformation)
    ),
  [types.CANDIDATE_PROFILE_SET_UNIVERSITIES_COLLEGES]: (
    state,
    { universitiesColleges }
  ) =>
    state.set(
      candidateProfileStateKeys.universitiesColleges,
      Immutable.fromJS(universitiesColleges)
    ),
  [types.CANDIDATE_PROFILE_SET_TEACHING_CREDENTIALS]: (
    state,
    { teachingCredentials }
  ) =>
    state.set(
      candidateProfileStateKeys.teachingCredentials,
      Immutable.fromJS(teachingCredentials)
    ),
});



// WEBPACK FOOTER //
// ./src/reducers/candidate/candidate-profile/candidate-profile.js